import * as yup from 'yup';
export const taskSchema = yup.object().camelCase().required().shape({
    id: yup.string().required(),
    taskName: yup.string().required(),
    assignedTo: yup.string().nullable(),
    assignedToName: yup.string().nullable(),
    assignedBy: yup.string().nullable(),
    assignedByName: yup.string().nullable(),
    dueDate: yup.date().nullable(),
    taskNotes: yup.string().nullable(),
    completedAt: yup.date().nullable(),
    status: yup.string().nullable(),
    patientId: yup.string().nullable(),
    patientName: yup.string().nullable(),
    practiceId: yup.string().nullable(),
    dob: yup.string().nullable(),
    lastReportId: yup.string().nullable(),
    practiceName: yup.string().nullable()
});
